var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.83 5.92A5.287 5.287 0 0 0 20.546.636H5.919A5.287 5.287 0 0 0 .636 5.919v14.628A5.287 5.287 0 0 0 5.92 25.83h4.063c.67 0 1.219-.549 1.219-1.22 0-.67-.549-1.218-1.219-1.218H5.919a2.847 2.847 0 0 1-2.845-2.845V5.92A2.847 2.847 0 0 1 5.92 3.075h14.628a2.847 2.847 0 0 1 2.844 2.844v4.064c0 .67.549 1.218 1.22 1.218.67 0 1.218-.548 1.218-1.219V5.92z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.328 13.64c-.67 0-1.22.548-1.22 1.219v3.25h-3.25c-.67 0-1.219.549-1.219 1.22 0 .67.549 1.218 1.22 1.218h3.25v3.251c0 .67.548 1.22 1.219 1.22.67 0 1.219-.55 1.219-1.22v-3.25h3.25c.671 0 1.22-.55 1.22-1.22 0-.67-.549-1.219-1.22-1.219h-3.25v-3.25c0-.67-.549-1.22-1.22-1.22z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Icon);
export default __webpack_public_path__ + "static/media/step1-icon.53f23549fb76a1d83d258dfb410a7cc4.svg";
export { ForwardRef as ReactComponent };